import { render, staticRenderFns } from "./MatterPresentation.vue?vue&type=template&id=07a3c639&scoped=true"
import script from "./MatterPresentation.vue?vue&type=script&lang=js"
export * from "./MatterPresentation.vue?vue&type=script&lang=js"
import style0 from "./MatterPresentation.vue?vue&type=style&index=0&id=07a3c639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a3c639",
  null
  
)

export default component.exports